export const realEstate = {
  realEstateOverview: 'Immobilienübersicht',
  createRealEstate: 'Neue Immobilie erstellen',
  return: 'Zurück',
  basicData: 'Grunddaten',
  constructionYear: 'Baujahr',
  realEstateType: 'Immobilientyp',
  ownerType: 'Besitzstatus',
  notes: 'Notizen',
  roofType: 'Dachtyp',
  owner: 'Eigentümer',
  components: 'Komponente',
  editData: 'Grunddaten bearbeiten',
  deleteData: 'Grunddaten löschen',
  delete: 'Löschen',
  deleteText: 'Sind Sie sich sicher, dass Sie diese Immobilie löschen wollen?',
  updateRealEstateErrorText: 'Immobilie konnte nicht angepasst werden.',
  buyer: 'Käufer',
  manager: 'Verwalter',
  emptyRealEstateOverview:
    'Um Ihre Immobilienübersicht zu sehen, müssen Sie zuerst eine Immobilie erstellen.',
  overviewRealEstate: 'Überblick auf Ihre Immobilien und deren Bauteilen.',
}
